import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Device } from '@capacitor/device';

@Component({
    selector: 'app-version-mismatch-modal',
    template: `
    <div class="modal-header">
      <h4 class="modal-title" i18n>Update durchführen</h4>
      <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
              (click)="activeModal.close()"></button>
    </div>
    <div class="modal-body">
      <div class="d-flex justify-content-between pb-2" i18n>
        Sie nutzen eine veraltete Version der App. Gehen Sie in den App Store/Google Play Store und führen ein Update durch.
      </div>
    </div>
    <div class="modal-footer justify-content-center align-items-center p-2 flex-row">
      <button type="button" class="btn btn-lg btn-info w-100" (click)="openAppStore()" i18n>
        Zum App Store
      </button>
    </div>
  `,
    standalone: false
})

export class VersionMismatchModalComponent {
  constructor(public activeModal: NgbActiveModal) {
  }

  async openAppStore() {
    const deviceInfo = await Device.getInfo();

    switch(deviceInfo.platform) {
      case 'android':
        this.openPlayStore();
        break;
      case 'ios':
        this.openAppStoreIOS();
        break;
      default:
        // Fallback to Play Store for web/other platforms
        this.openPlayStore();
    }
  }

  private openPlayStore() {
    const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=de.versacommerce.pos_hybrid';
    window.open(PLAY_STORE_URL, '_blank');
  }

  private openAppStoreIOS() {
    const IOS_APP_STORE_ID = 'id1419591657';
    const APP_STORE_URL = `https://apps.apple.com/de/app/versapos/${IOS_APP_STORE_ID}`;

    window.open(APP_STORE_URL, '_blank');
  }
}
